import { ReactNode } from 'react';
import styled from 'styled-components';

const TruncatedSpan = styled('span').attrs((props) => ({ title: props.children }))`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface TruncatedTextProps {
  className?: string;
  children: ReactNode;
}

const TruncatedText = ({ className, children }: TruncatedTextProps) => (
  <TruncatedSpan className={className}>{children}</TruncatedSpan>
);

export default TruncatedText;
